/** Query key prefix for account domain React Query keys. */
export const ACCOUNT_PREFIX = 'account';

/** Retro-redeem reads */
export const SAUDI_REWARDS_RETRO_REDEEM_PREFIX = 'saudi-rewards-retro-redeem';
